<template>
  <div>
    <button
      @click="showImage()"
      class="w-8 h-8 hover:bg-gray-100 rounded-lg bg-green-50 mr-2 text-gray-500"
    >
      <VIcon style="color: inherit">mdi-image</VIcon>
    </button>
    <v-dialog v-model="showImageData.showBox" max-width="700">
      <v-card>
        <v-toolbar dense flat>
          <v-toolbar-title class="text-body-2 font-weight-bold grey--text">
            نمایش بارنامه
          </v-toolbar-title>
        </v-toolbar>
        <iframe
          v-if="showImageData.isPdf"
          height="700px"
          width="100%"
          :src="showImageData.path"
        ></iframe>
        <v-img
          class="mx-auto"
          height="300"
          lazy-src="https://picsum.photos/id/11/100/60"
          max-width="500"
          :src="showImageData.path"
          v-if="showImageData.isPdf === false"
        >
          <template v-slot:placeholder>
            <div class="d-flex align-center justify-center fill-height">
              <v-progress-circular
                color="grey-lighten-4"
                indeterminate
              ></v-progress-circular>
            </div>
          </template>
        </v-img>

        <v-card-actions class="pt-5">
          <v-spacer></v-spacer>
          <div class="flex justify-end my-4">
            <a id="download-link" href="#" download class="hidden"
              >دانلود فایل</a
            >
            <v-btn color="success" class="ml-2" @click="download">
              <VIcon style="color: inherit">mdi-download</VIcon>
              دانلود بارنامه
            </v-btn>
            <v-btn
              color="grey"
              text
              variant="outlined"
              class="body-2 font-weight-bold"
              @click="showImageData.showBox = false"
              >بستن
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axiosApi from "@/plugins/axios";

export default {
  props: ["itemId", "remittanceHistory"],
  data() {
    return {
      showImageData: {
        showBox: false,
        isPdf: false,
        path: "",
      },
    };
  },
  methods: {
    download() {
      fetch(this.showImageData.path)
        .then((response) => response.blob())
        .then((blob) => {
          const url = URL.createObjectURL(blob);
          const link = document.getElementById("download-link");
          link.href = url;
          link.download = "عکس بارنامه";
          link.click();
          URL.revokeObjectURL(url);
        });
    },
    showImage() {
      var method = null;
      if (this.remittanceHistory) {
        method = `v2/company/remittanceHistory/showWaybillImage`;
      } else {
        method = `v2/admin/remittance/showWaybillImage`;
      }
      axiosApi()
        .post(method, {
          remittanceHistory_id: this.itemId,
        })
        .then((result) => {
          this.showImageData.path = result.data.data.path;
          this.showImageData.showBox = true;
          let pdf = this.showImageData.path.search("pdf");
          if (pdf != "-1") {
            this.showImageData.isPdf = true;
          }
        });
    },
  },
};
</script>